import service from '@/helpers/serviceGPAO'

export function getMercuriales(etablissementId) {
  return service.get('mercuriale/' + etablissementId + '/toutes')
}

export function getMercurialesDate(etablissementId, dateMercuriale, tauxMercu) {

  return service.get('mercuriale/' + (dateMercuriale ? 'avecDate/' + dateMercuriale + '/' : '') + etablissementId + '/' + (tauxMercu ? tauxMercu + '/' : '') + 'toutes')
}

export function getIngredientsPourRechercheComplete() {
  return service.get('mercuriale/ingredientsPourRecherche')
}

export function getRecettesPourRechercheComplete(etablissementId) {
  return service.get('mercuriale/' + etablissementId + '/recettesPourRecherche')
}

export function getMercuriale(etablissementId, familleId, estGamme, tauxMercu) {
  return service.get('mercuriale/' + etablissementId + (estGamme ? '/gamme/' : '/famille/') + familleId + (tauxMercu ? '/' + tauxMercu : ''))
}

export function obtenirProduitsComplementaires(fourId, famId, dateActif) {
  return service.get('mercuriale/obtenirProduitsComplementaires/' + fourId + '/' + famId + '/' + dateActif)
}

export function obtenirMercurialesComplementaires() {
  return service.get('mercuriale/obtenirMercurialesComplementaires')
}

export function arreterMercurialesComplementaires(fourId, famId, dateDebut, dateFin) {
  return service.post('mercuriale/arreterMercurialeComplementaire/' + fourId + '/' + famId + '/' + dateDebut + '/' + dateFin)
}

export function exporterProduitsComplementaires(fourId, famId, dateActif, lettreMercu) {
  return service.get('mercuriale/exporterProduitsComplementaires/' + fourId + '/' + famId + '/' + dateActif + '/' + lettreMercu, { responseType: 'blob' })
}

export function exporterTrameViergeProduitsComplementaires() {
  return service.get('mercuriale/exporterTrameViergeProduitsComplementaires', { responseType: 'blob' })
}

export function importerProduitsComplementaires(fourId, famId, dateActif, lettre, fichier) {
  return service.post('mercuriale/importerProduitsComplementaires/' + fourId + '/' + famId + '/' + dateActif + '/' + lettre, fichier)
}

export function ajouterModifierProduitComplementaire(vueProd) {
  return service.post('mercuriale/ajouterModifierProduitComplementaire', vueProd)
}

export function supprimerProduitsComplementaires(fourId, famId, dateActif) {
  return service.delete('mercuriale/supprimerProduitsComplementaires/' + fourId + '/' + famId + '/' + dateActif)
}

export function supprimerUnProduitComplementaire(vueProd) {
  return service.post('mercuriale/supprimerUnProduitComplementaire', vueProd)
}

export function obtenirLettresMercuriales() {
  return service.get('mercuriale/obtenirListeLettresMercuriales')
}

export function getSelection(id) {
  return service.get('users/selection/' + id)
}

export function tousArticlesPour(etablissementId, produitOuIngredientId, familleId, grammage, fournisseurId) {
  var url = 'mercuriale/tousarticles/' + etablissementId + '/' + produitOuIngredientId
  if (familleId) {
    url += "/" + familleId
  }
  if (grammage) {
    url += "/" + grammage
  }
  if (fournisseurId) {
    url += "/" + fournisseurId
  }
  return service.get(url)
}

export function tousArticlesFamilles(etablissementId, ingredientId, fournisseurId, grammage) {
  var url
  if (fournisseurId) {
    url = 'mercuriale/tousarticlesfamillespourfournisseur/' + fournisseurId + '/' + etablissementId + '/' + ingredientId
  } else {
    url = 'mercuriale/tousarticlesfamilles/' + etablissementId + '/' + ingredientId
  }
  if (grammage) {
    url += '/' + grammage
  }
  return service.get(url)
}

export function tousArticlesParReference(etablissementId, reference) {
  return service.get('mercuriale/tousArticlesParReference/' + etablissementId + '/' + reference)
}

export function getFavoris(etabId) {
  return service.get('mercuriale/favoris/' + etabId)
}

export function dupliquerFavoris(etablissementOrigineId, params) {
  return service.post('mercuriale/favoris/dupliquer/' + etablissementOrigineId, params)
}